@import '../../../../../../constants/spacing.module.less';

.modal-header {
  color: var(--grey-800);
}

.modal-body {
  padding: @space-16;
  display: flex;
  flex-flow: column nowrap;
  gap: @space-16;
}

.primary-message {
  color: var(--gray-212c36);
}

.feature-list {
  padding-left: @space-20;
}

.feature-item {
  display: list-item;
  list-style-type: disc;
}
